<template lang="pug">
v-dialog(v-model="dialog", width='800')
  v-card
    v-card-text.pa-0
      v-tabs(v-model="tabActive" color="primary" slider-color="white" dark centered)
        v-tab(key="tab-dados")
          | Dados
        v-tab(key="tab-agendamento")
          | Agendamento
        v-tab(key="tab-impressao")
          | Impressão
        v-tab(key="tab-template")
          | Modelo de Laudo
        v-tab(key="tab-header")
          | Cabeçalho e Rodapé
        v-tab(key="tab-integration")
          | Integração
        v-tab(key="tab-customization")
          | Customização
      v-tabs-items(v-model="tabActive")
        v-tab-item(key="tab-dados")
          template
            v-container
              u-form(v-model="result", :json="json", :resultJSON="true")
        v-tab-item(key="tab-agendamento")
          template
            v-form
              v-container
                v-layout.row.wrap
                  v-checkbox.ma-0.pr-2(v-model="schedule.activated" :label="'ativo'")
                  v-flex.md12.xs12
                    v-label {{label="Dias de atendimento"}}
                  v-checkbox.ma-0.pr-2(v-for="item in days", v-model="selectedDays" :label="item", :value="item" :key="item")
                  v-flex.md2.xs6
                  v-flex.md2.xs6
                    v-text-field.md4.xs6(label="horário de inicio" placeholder=" " v-model="schedule.startTime" :type="'time'")
                  v-flex.md2.xs6
                    v-text-field.md4.xs6(label="horário de fim" placeholder =" " v-model="schedule.endTime" :type="'time'")
                  v-flex.md4.xs6
                    v-text-field.md4.xs6(label="tempo médio de atendimento (em minutos)" placeholder =" " v-model.number="schedule.procedureAverageTime" :type="'number'")
                  v-flex.md4.xs6
                    v-text-field.md4.xs6(label="modalidade (padrão)" placeholder =" " v-model="schedule.modality" :type="'text'")
                  v-flex.md12.xs6
                    v-text-field.md4.xs6(label="procedimento (padrão)" placeholder =" " v-model="schedule.procedure" :type="'text'")
        v-tab-item(key="tab-impressao")
          template
            v-form
              v-container
                v-layout.row.wrap
                  v-flex.md2.xs6
                    v-select(label="Formato do papel" placeholder=" " hide-details v-model="printConfig.paperFormat" :items="paperFormats" :rules="[v => !!v || 'Campo obrigatório']")
                  v-flex.md2.xs6
                    v-text-field(label="Largura da página" placeholder=" " suffix="mm" v-model="printConfig.pageWidth" :type="'number'" :rules="[v => !v || v >= 0 || 'Valor não pode ser negativo']")
                  v-flex.md2.xs6
                    v-text-field(label="Altura da página" placeholder=" " suffix="mm" v-model="printConfig.pageHeight" :type="'number'" :rules="[v => !v || v >= 110 || 'Valor não pode ser menor que 110mm']")
                  v-flex.md2.xs6
                    v-select(label="Layout da página" placeholder=" " hide-details v-model="printConfig.pageOrientation" :items="paperOrientations" :rules="[v => !!v || 'Campo obrigatório']")
                  v-flex.md2.xs6
                    v-text-field(label="Margem topo" placeholder=" " suffix="mm" v-model="printConfig.topMargin" :type="'number'" :rules="[v => !v || v >= 0 || 'Valor não pode ser negativo']")
                  v-flex.md2.xs6
                    v-text-field(label="Margem inferior" placeholder=" " suffix="mm" v-model="printConfig.bottomMargin" :type="'number'" :rules="[v => !v || v >= 0 || 'Valor não pode ser negativo']")
                  v-flex.md2.xs6
                    v-text-field(label="Margem esquerda" placeholder=" " suffix="mm" v-model="printConfig.leftMargin" :type="'number'" :rules="[v => !v || v >= 0 || 'Valor não pode ser negativo']")
                  v-flex.md2.xs6
                    v-text-field(label="Margem direita" placeholder=" " suffix="mm" v-model="printConfig.rightMargin" :type="'number'" :rules="[v => !v || v >= 0 || 'Valor não pode ser negativo']")
                  v-flex.md3.xs6
                    v-text-field(label="Quantidade de gráficos" placeholder=" " v-model="printConfig.chartsCount" :type="'number'" :rules="[v => !v || v >= 0 || 'Valor não pode ser negativo']")
                  v-flex.md3.xs6
                    v-text-field(label="Altura máxima do gráfico" suffix="mm" placeholder=" " v-model="printConfig.chartsHeightMax" :type="'number'" :rules="[v => !v || v >= 0 || 'Valor não pode ser negativo']")
                  v-flex.md3.xs6
                    v-text-field(label="Quantidade de Imagens" placeholder=" " v-model="printConfig.imagesCount" :type="'number'" :rules="[v => !v || v >= 0 || 'Valor não pode ser negativo']")
                  v-flex.md3.xs6
                    v-text-field(label="Altura máxima da imagem" suffix="mm" placeholder=" " v-model="printConfig.imagesHeightMax" :type="'number'" :rules="[v => !v || v >= 0 || 'Valor não pode ser negativo']")
                  v-flex.md3.xs6
                    v-checkbox(label="Quebra de texto no Laudo" v-model="printConfig.splitReport")
                  v-flex.md3.xs6
                    v-checkbox(label="Quebra de imagens no Laudo'" v-model="printConfig.splitImageReport" :type="'boolean'")
                  v-flex.md3.xs6
                    v-checkbox(label="Quebra de gráficos no Laudo'" v-model="printConfig.splitGraphicReport" :type="'boolean'")
                  v-flex.md3.xs6
                    v-checkbox(label="Remover titulo 'Paciente'" v-model="printConfig.pacientTitle" :type="'boolean'")
                  v-flex.md3.xs6
                    v-checkbox(label="Remover titulo 'Informações'" v-model="printConfig.infomationTitle" :type="'boolean'")
        v-tab-item(key="tab-template")
          template
            v-form
              v-container
                v-layout.row.wrap
                  v-flex.md6.py-0
                    v-checkbox(label="Utilizar laudo personalizado?" dense v-model="printConfig.customReport" :type="'boolean'")
                  v-flex.md6
                    v-btn(@click="saveLayoutConfig" flat icon class="right" title="Salvar modelo de laudo")
                      v-icon publish
                  v-flex.md12.pt-0
                    v-textarea(
                      v-model="printConfig.template"
                      label="Modelo de Laudo"
                      placeholder=" "
                      rows="15"
                      outline
                    )
        v-tab-item(key="tab-header")
          template
            v-form
              v-container
                v-layout.row.wrap
                  v-flex
                    v-textarea(
                      v-model="printConfig.header"
                      label="Cabeçalho"
                      placeholder=" "
                      rows="15"
                      outline
                    )
                  v-flex
                    v-textarea(
                      v-model="printConfig.footer"
                      label="Rodapé"
                      placeholder=" "
                      rows="15"
                      outline
                    )
        v-tab-item(key="tab-integration")
          template
            v-form
              v-container
                v-layout.row.wrap
                  v-flex.md12.xs12
                    v-label {{label="Api Key"}}
                  v-flex.md6.xs6
                    v-text-field( v-if="!isGenerating" label="apiKey" disabled placeholder=" " v-model="integrations.apiKey")
                  v-flex.md4.xs4
                    v-btn(@click="generateApiKey()" color="primary" title="Gerar Api Key") Gerar Api Key
                  v-flex.md12.xs12
                    v-label {{label="Netpacs"}}
                  v-flex.md6.xs6
                    v-text-field(label="url" placeholder=" " v-model="integrations.netpacs.url")
                  v-flex.md4.xs4
                    v-text-field(label="token" placeholder=" " v-model="integrations.netpacs.token")
                  v-flex.md2.xs2
                    v-text-field(label="version" placeholder=" " v-model="integrations.netpacs.version")
                  v-flex.md12.xs12
                    v-label {{label="Animati"}}
                  v-flex.md6.xs6
                    v-text-field(label="url" placeholder=" " v-model="integrations.animati.url")
                  v-flex.md4.xs4
                    v-text-field(label="token" placeholder=" " v-model="integrations.animati.token")
                  v-flex.md2.xs2
                    v-text-field(label="version" placeholder=" " v-model="integrations.animati.version")
                  v-flex.md12.xs12
                    v-label {{label="Smartris"}}
                  v-flex.md6.xs6
                    v-text-field(label="url" placeholder=" " v-model="integrations.smartris.url")
                  v-flex.md4.xs4
                    v-text-field(label="token" placeholder=" " v-model="integrations.smartris.token")
                  v-flex.md2.xs2
                    v-text-field(label="version" placeholder=" " v-model="integrations.smartris.version")
                  v-flex.md12.xs12
                    v-label {{label="Feegow"}}
                  v-flex.md6.xs6
                    v-text-field(label="url" placeholder=" " v-model="integrations.feegow.url")
                  v-flex.md4.xs4
                    v-text-field(label="token" placeholder=" " v-model="integrations.feegow.token")
                  v-flex.md2.xs2
                    v-text-field(label="version" placeholder=" " v-model="integrations.feegow.version")
        v-tab-item(key="tab-customization")
          template
            v-form
              v-container
                v-layout.row.wrap
                  v-flex.md6.py-0
                    v-label {{customJsonResponse}}
                  v-flex.md6.py-0
                    v-btn(@click="saveCustomization" flat icon class="right" title="Salvar customização")
                      v-icon publish
                  v-flex.md12.pt-0
                    v-textarea(
                      v-model="customJsonText"
                      label="Customização"
                      rows="20"
                      outline
                    )
    v-divider
    v-card-actions
      v-spacer
      v-btn(color='default', flat, @click='dialog = false') {{ $t('words.cancel') }}
      v-btn(color='primary', @click='save()') {{ $t('words.save') }}
</template>

<script>
import UForm from '@/components/form/form'
import paperConfig from '@/../functions/shared/paperConfig'
import firebase from 'firebase/app'
// import _ from 'lodash'

const DPI = 72

export default {
  name: 'company',

  components: {
    UForm
  },

  props: {
    value: {
      type: Boolean
    },
    company: {
      type: Object
    }
  },

  data () {
    return {
      dialog: false,
      tabActive: null,
      isGenerating: false,
      result: {},
      customJsonText: '',
      customJsonResponse: '',
      printForm: {},
      printConfig: {
        template: ''
      },
      integrations: {
        netpacs: {
          token: null,
          url: null,
          version: null
        },
        animati: {
          token: null,
          url: null,
          version: null
        },
        smartris: {
          token: null,
          url: null,
          version: null
        },
        feegow: {
          token: null,
          url: null,
          version: null
        }
      },
      days: [
        'segunda', 'terça',
        'quarta', 'quinta',
        'sexta', 'sábado', 'domingo'
      ],
      selectedDays: [],
      schedule: {
        activated: false,
        workingDays: {
          segunda: false,
          terça: false,
          quarta: false,
          quinta: false,
          sexta: false,
          sábado: false,
          domingo: false
        }
      },
      preProssesInnerHtml: null,
      json: {
        label: 'Company',
        type: 'panel',
        key: 'company',
        components: [
          {
            type: 'textfield',
            key: 'name',
            label: 'Razão social',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'email',
            label: 'Email',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'identity',
            label: 'CNPJ',
            style: 'xs12 sm4'
          },
          {
            type: 'label',
            label: 'Impressão',
            style: 'xs12'
          },
          {
            type: 'textfield',
            key: 'address',
            label: 'Endereço',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'number',
            label: 'Número',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'district',
            label: 'Bairro',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'city',
            label: 'Cidade',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'state',
            label: 'Estado',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'zipCode',
            label: 'CEP',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'site',
            label: 'Site',
            style: 'xs12 sm4'
          },
          {
            type: 'textfield',
            key: 'phone',
            label: 'Telefone',
            style: 'xs12 sm4'
          },
          {
            type: 'label',
            label: 'Segurança',
            style: 'xs12'
          },
          {
            type: 'v-checkbox',
            key: 'security.totpEnabled',
            label: 'Exigir autenticação de dois fatores para publicar/editar laudos',
            style: 'xs12 sm6'
          },
          {
            type: 'label',
            label: 'Imagens',
            style: 'xs12'
          },
          {
            type: 'textfield',
            key: 'logo',
            label: 'Logotipo',
            style: 'xs12 sm6'
          },
          {
            type: 'textfield',
            key: 'reportHeader',
            label: 'Cabeçalho do laudo',
            style: 'xs12 sm6'
          }
        ]
      }
    }
  },

  computed: {
    paperFormats () {
      return Object.keys(paperConfig.formats)
    },
    paperOrientations () {
      return Object.entries(paperConfig.layouts).map(e => ({text: e[1], value: e[0]}))
    }
  },

  watch: {
    value (val) {
      this.dialog = val
      if (!val) return
      this.result = {
        company: this.company
      }
      if (this.company.iuid) {
        this.loadPrintConfig()
        this.loadCompanyIntegrations()
        this.loadCompanySchedule()
        this.loadFormCustomization()
      }
    },
    dialog (val) {
      if (!val) this.result = {}
      this.$emit('input', val)
    }
  },

  methods: {
    async save () {
      const workingDays = {
        segunda: false,
        terça: false,
        quarta: false,
        quinta: false,
        sexta: false,
        sábado: false,
        domingo: false
      }
      for (let index = 0; index < this.selectedDays.length; index++) {
        workingDays[this.selectedDays[index]] = true
      }
      this.schedule.workingDays = workingDays
      let company = this.result.company

      // Garante que o objeto security existe
      if (!company.security) {
        company.security = {}
      }

      // Garante que totpEnabled seja booleano
      company.security.totpEnabled = !!company.security.totpEnabled

      company.nameFull = company.name
      company.schedule = this.schedule
      // Print save
      const printConfig = {}
      for (const key in this.printConfig) {
        if (Object.hasOwnProperty.call(this.printConfig, key)) {
          const element = this.printConfig[key]
          if (['template', 'header', 'footer', 'paperFormat', 'pageOrientation', 'customReport'].includes(key)) {
            printConfig[key] = element
          } else if (key.endsWith('Count') || key.endsWith('Report') || key.endsWith('Title')) {
            printConfig[key] = Number(element)
          } else {
            printConfig[key] = this.convertMMToPixel(element)
          }
        }
      }

      // Salva as margens do laudo
      printConfig.margin = {
        top: this.printConfig.topMargin || null,
        bottom: this.printConfig.bottomMargin || null,
        left: this.printConfig.leftMargin || null,
        right: this.printConfig.rightMargin || null
      }

      // Salvar Integrations
      this.company.integrations = this.integrations

      // Store save
      this.$store.dispatch('saveCompany', company)
        .then((doc) => {
          return this.$store.dispatch('savePrintConfig', { printConfig, iuid: company.iuid || doc.id })
        })
        .then(() => {
          this.dialog = false
          return this.$store.dispatch('loadAdminCompanies')
        })
        .catch((err) => {
          console.error(err)
          return window.alert('Erro ao salvar empresa.')
        })

      // SALVA CUSTOMIZAÇÃO DE LAUDO
      this.saveCustomization()
    },

    saveLayoutConfig () {
      const printConfig = {
        template: this.printConfig.template,
        header: this.printConfig.header,
        footer: this.printConfig.footer,
        customReport: this.printConfig.customReport
      }
      return this.$store.dispatch('savePrintConfig', { printConfig, iuid: this.company.iuid })
    },

    async saveCustomization () {
      this.customJsonResponse = ''
      try {
        if (JSON.parse(this.customJsonText)) {
          const formCustom = {
            customization: this.customJsonText,
            updatedAt: firebase.firestore.Timestamp.now()
          }
          await this.$store.dispatch('saveFormCustom', { formCustom, iuid: this.company.iuid })
          this.customJsonResponse = 'Personalização salva com sucesso!'
        } else this.customJsonResponse = 'Estrurura JSON inválida'
      } catch (e) {
        this.customJsonResponse = 'JSON inválido: ' + e.message
      }
    },

    loadPrintConfig () {
      this.$store.dispatch('loadPrintConfig', this.company.iuid)
        .then((printConfig) => {
          this.printConfig = { template: '' }
          for (const key in printConfig) {
            if (Object.hasOwnProperty.call(printConfig, key)) {
              const element = printConfig[key]
              if (['template', 'header', 'footer', 'paperFormat', 'pageOrientation', 'customReport'].includes(key) || key.endsWith('Count') || key.endsWith('Report') || key.endsWith('Title')) {
                this.printConfig[key] = element
              } else {
                this.printConfig[key] = this.convertPixelToMM(element)
              }
            }
          }
          // Verifica se existe a margim no objeto
          if (printConfig.margin) {
            // Define as margens
            this.printConfig.topMargin = printConfig.margin.top
            this.printConfig.bottomMargin = printConfig.margin.bottom
            this.printConfig.leftMargin = printConfig.margin.left
            this.printConfig.rightMargin = printConfig.margin.right
          }
        })
        .catch((err) => {
          console.error(err)
          return window.alert('Erro ao carregar configurações de impressão.')
        })
    },

    loadFormCustomization () {
      this.$store.dispatch('loadFormCustom', this.company.iuid)
        .then((formCustom) => {
          this.customJsonText = (formCustom && formCustom.customization) ? formCustom.customization : ''
        })
        .catch((err) => {
          console.error(err)
          return window.alert('Erro ao carregar formulário customizado.')
        })
    },

    loadCompanyIntegrations () {
      if (this.company && this.company.integrations) {
        this.integrations = this.company.integrations
        if (!this.integrations.netpacs) {
          this.integrations.netpacs = {}
          this.integrations.netpacs.url = ''
          this.integrations.netpacs.token = ''
          this.integrations.netpacs.version = ''
        }
        if (!this.integrations.animati) {
          this.integrations.animati = {}
          this.integrations.animati.url = ''
          this.integrations.animati.token = ''
          this.integrations.animati.version = ''
        }
        if (!this.integrations.smartris) {
          this.integrations.smartris = {}
          this.integrations.smartris.url = ''
          this.integrations.smartris.token = ''
          this.integrations.smartris.version = ''
        }
        if (!this.integrations.feegow) {
          this.integrations.feegow = {}
          this.integrations.feegow.url = ''
          this.integrations.feegow.token = ''
          this.integrations.feegow.version = ''
        }
      }
    },

    loadCompanySchedule () {
      if (this.company && this.company.schedule) {
        if (this.company.schedule.activated) {
          this.schedule.activated = true
        }
        if (this.company.schedule.workingDays) {
          this.schedule.workingDays = this.company.schedule.workingDays
          let keys = []
          const workingDays = this.schedule.workingDays
          keys = Object.keys(workingDays)
          this.selectedDays = keys.filter(function (key) {
            return workingDays[key]
          })
        }
        if (this.company.schedule.startTime) {
          this.schedule.startTime = this.company.schedule.startTime
        }
        if (this.company.schedule.endTime) {
          this.schedule.endTime = this.company.schedule.endTime
        }
        if (this.company.schedule.procedureAverageTime) {
          this.schedule.procedureAverageTime = this.company.schedule.procedureAverageTime
        }
        if (this.company.schedule.modality) {
          this.schedule.modality = this.company.schedule.modality
        }
        if (this.company.schedule.procedure) {
          this.schedule.procedure = this.company.schedule.procedure
        }
      }
    },

    // TODO: Build sample content for preview using handlebars.
    // Build sample content for preview.
    buildSampleContent (content) {
      return 'content'
    },

    convertMMToPixel (value) {
      if (!value) return null
      return Math.round(value * DPI / 25.4)
    },

    convertPixelToMM (value) {
      if (!value) return null
      return (value / (DPI / 25.4)).toFixed(2)
    },

    async generateApiKey () {
      this.isGenerating = true
      let apiKey = ''
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      for (let i = 0; i < 32; i++) {
        apiKey += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      this.integrations.apiKey = apiKey
      this.isGenerating = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Company.vue